import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

import { useOidcAuth } from '@/features/login/model/use-oidc-auth';
import { OidcProvider } from '@/shared/config/oidc-config';

export const ExternalUsersSection = () => {
  const { loginWithRedirect, isLoading } = useOidcAuth(OidcProvider.CIAM);

  return (
    <Card>
      <CardHeader className="text-center">
        <CardTitle className="text-lg">External Single Sign-On Users</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button variant="secondary" className="w-full" size="lg" onClick={loginWithRedirect} disabled={isLoading}>
          {isLoading ? 'Logging in...' : 'Login to RITA'}
        </Button>
      </CardContent>
    </Card>
  );
};
